export default __webpack_public_path__ + "static/media/Yesterday.d0bccb49.svg";